import apiClient from './apiClient';
import { Qualification, QualificationCreate, QualificationBase } from '../types';

const apiBaseURL = '/use-cases';

export const qualificationService = {
  /**
   * Récupère la dernière qualification pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   * @returns La qualification ou null si aucune n'existe
   */
  async getLatest(useCaseId: string): Promise<Qualification | null> {
    const response = await apiClient.get<Qualification | null>(`${apiBaseURL}/${useCaseId}/qualify/latest/`);
    return response.data;
  },

  /**
   * Récupère l'historique des qualifications pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   */
  async getHistory(useCaseId: string): Promise<Qualification[]> {
    const response = await apiClient.get<Qualification[]>(`${apiBaseURL}/${useCaseId}/qualify/history/`);
    return response.data;
  },

  /**
   * Crée une nouvelle qualification pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   * @param data - Les données de la qualification
   */
  async create(useCaseId: string, data: QualificationCreate): Promise<Qualification> {
    const response = await apiClient.post<Qualification>(`${apiBaseURL}/${useCaseId}/qualify/`, data);
    return response.data;
  },

  /**
   * Met à jour une qualification existante
   * @param useCaseId - L'ID du cas d'usage
   * @param qualificationId - L'ID de la qualification
   * @param data - Les données de mise à jour
   */
  async update(useCaseId: string, qualificationId: string, data: QualificationBase): Promise<Qualification> {
    const response = await apiClient.put<Qualification>(`${apiBaseURL}/${useCaseId}/qualify/${qualificationId}`, data);
    return response.data;
  },

  /**
   * Supprime une qualification
   * @param useCaseId - L'ID du cas d'usage
   * @param qualificationId - L'ID de la qualification
   */
  async delete(useCaseId: string, qualificationId: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}/${useCaseId}/qualify/${qualificationId}`);
  }
};

export default qualificationService;
